import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div className='bg-black footer'>
            <div>
                <h5 className='text-white mb-3'>Contact Information</h5>
                <p className='text-white mb-0'>Email: talukderars@gmail.com</p>
                <p className='text-white'>phone: +8801629396785</p>

            </div>

        </div>
    );
};

export default Footer;